<template>
  <modal-custom
    v-if="showModal"
    :title="title"
    :text="text"
    :hasFooter="true"
    :successText="successText"
    :cancelText="cancelText"
    :gtmSuccess="gtmSuccess"
    :gtmCancel="gtmCancel"
    :swapButtons="swapButtons"
    @modalSuccess="yes"
    @modalCancel="no">
  </modal-custom>
</template>

<script>
import ModalCustom from '@/components/Modals/Custom'
import i18n from '@/i18n'

export default {
  components: {
    ModalCustom
  },
  props: ['title', 'text', 'yesText', 'noText', 'gtmSuccess', 'gtmCancel', 'swapButtons'],
  data: function () {
    return {
      arguments: [],
      showModal: false,
      resolve: null,
      successText: this.yesText || i18n.t('yes'),
      cancelText: this.noText || i18n.t('no')
    }
  },
  methods: {
    show: function () {
      this.arguments = [...arguments]
      this.showModal = true
    },
    yes: function () {
      this.showModal = false
      this.$emit('yes', ...this.arguments)
    },
    no: function () {
      this.showModal = false
      this.$emit('no', ...this.arguments)
    }
  }
}
</script>
